export default {
  PENDING: 0,
  ACCEPTED: 1,
  REJECTED: 2,
  TIMEOUT: 3,
  SEALED_BID: 4,
};
